import request from '../utils/request'
export const getHomeIndexList = data =>
    request({
        url: '/home/v1/homeApi/getHomeIndexList',
        method: "POST",
        data
    });
export const getHomeIndexShopList = data =>
    request({
        url: '/home/v1/homeApi/getHomeIndexShopList',
        method: "POST",
        data
    });
export const wxSubmitOpenHomeBagData = data =>
    request({
        url: '/eye/v1/userOpenHomeOrderApi/wxSubmitOpenHomeBagData',
        method: "POST",
        data
    });
export const getOpenHomeBag = data =>
    request({
        url: '/eye/v1/userOpenHomeOrderApi/getOpenHomeBagData',
        method: "POST",
        data
    });
export const getUserHealthGoldInfo = data =>
    request({
        url: '/home/v1/homeApi/getUserHealthGoldInfo',
        method: "POST",
        data
    });
export const getUserHomeBagList = data =>
    request({
        url: '/home/v1/homeApi/getUserHomeBagList',
        method: "POST",
        data
    });
export const getHomeOrderList = data =>
    request({
        url: '/home/v1/homeApi/getHomeOrderList',
        method: "POST",
        data
    });
export const getUserOpenHomeOrderList = data =>
    request({
        url: '/eye/v1/userOpenHomeOrderApi/getUserOpenHomeOrderList',
        method: "POST",
        data
    });
export const getUserHomeUniqueCode = data =>
    request({
        url: '/home/v1/homeApi/getUserHomeUniqueCode',
        method: "POST",
        data
    });
export const getUserHomePayOrder = data =>
    request({
        url: '/home/v1/homeApi/getUserHomePayOrder',
        method: "POST",
        data
    });
export const getUserHomePayUrl = data =>
    request({
        url: '/home/v1/homeApi/getUserHomePayUrl',
        method: "POST",
        data
    });
export const gePageJsParam = data =>
    request({
        url: '/basic/weixin/weChatApi/gePageJsParam',
        method: "GET",
        data
    });
export const getWebPageJsParam = data =>
    request({
        url: '/basic/weixin/weChatApi/getWebPageJsParam',
        method: "POST",
        data
    });
